import { ColDef } from "ag-grid-community";

// EZ
import { CrudApiProtocol, CrudFilter, InputConfig } from "@template-ui/types";

// App
import { AppGridColumnTypes } from "../tables/ag-grid-cells/app-grid-column-types";

export const DEFAULT_ACTIVITY_LOG_COL_DEFS: ColDef[] = [
  { field: "addDate", headerName: "Timestamp", type: [AppGridColumnTypes.DateTimeColumn] },
  { field: "activity", headerName: "Activity" },
  { field: "bitsUser", headerName: "By User" },
];


export enum ActivityLogType {
  CommutationInvestigation = "commutation-investigation",
  BphFullInvestigation = "bph-full-investigation",
  LegalDecisionReview = "legal-decision-review",
}

export type ActivityLogContextValue = string | number | boolean | undefined;

export interface ActivityLogContext {
  /** Variant-specific context values (for example `caseId`, `planId`). */
  [key: string]: ActivityLogContextValue;
}

/**
 * Defines how a context value is mapped into Add Activity form-data payload.
 */
export interface ActivityLogAddActivityEndpointParamConfig {
  /** Key to read from `activityLogContext`. */
  contextKey: string;
  /** Target key appended to the multipart request payload. */
  formDataKey: string;
  /** Whether this value must be present before submit. */
  required?: boolean;
  /** Optional fallback used when `contextKey` is missing. */
  defaultValue?: ActivityLogContextValue;
}

export interface ActivityLogGridVariantConfig {
  settingsKey: string;
  readEndpoint: string;
  readEndpointProtocol?: CrudApiProtocol;
  staticFilters?: { [key: string]: CrudFilter };
  filterInputConfigs?: InputConfig[];
  addActivityEndpoint?: string;
  addActivityEndpointParams?: ActivityLogAddActivityEndpointParamConfig[];
  documentTypesModule?: string | null;
  documentTypesEndpoint?: string | null;
  colDefs?: ColDef[];
}

/**
 * @deprecated Use `ActivityLogGridVariantConfig` instead.
 */
export type ActivityLogEndpointConfig = ActivityLogGridVariantConfig;
